import { createSelector } from 'reselect';

export const getCheckedItemsOnTable = (state) => state.listing.checboxSelections;
export const getFilteredDataOnTable = (state) => state.listing.filteredData;
export const getClickedRowOnTable = (state) => state.listing.clickedRow;
export const getCheckedItemIds = createSelector(
  getCheckedItemsOnTable,
  (items) => items.map((item) => item.id),
);
